import React from "react";
import styled from "styled-components";

export default function Button({ onClick, label, variant="primary", disabled, className }) {
  return (
    <ButtonComponent
      onClick={onClick}
      variant={variant}
      disabled={disabled}
      className={`${className}`}
      // {...variant}
      // style={styles[variant] || styles["primary"]}
    >
      {label}
    </ButtonComponent>
  );
}

const styles = {
  primary: {
    backgroundColor: "#2251ff",
    color: "#FFF",
    border: "2px solid transparent",
    hoverBackgroundColor: "transparent",
    hoverBorder: "2px solid #2251ff",
    hoverColor: "#2251ff",
    borderRadius: "3rem",
  },
  secondary: {
    backgroundColor: "#2251ff",
    color: "#FFF",
    border: "2px solid transparent",
    hoverBackgroundColor: "transparent",
    hoverBorder: "2px solid rgb(213, 216, 255)",
    hoverColor: "rgb(213, 216, 255)",
    borderRadius: "3rem",
  },
  tertiary: {
    backgroundColor: "transparent",
    color: "#2251ff",
    border: "2px solid #2251ff",
    hoverBackgroundColor: "#f5f5f5",
    borderRadius: "3rem",
  }
};

const ButtonComponent = styled.button`
  background-color: ${(props) => styles[props.variant].backgroundColor};
  color: ${(props) => styles[props.variant].color};
  border: ${(props) => styles[props.variant].border};
  width: auto;
  height: 40px;
  padding: 0px 24px;
  font-size: 1rem;
  font-family: "Noto Sans", serif;
  font-weight: 600;
  line-height: 2rem;
  text-align: center;
  box-shadow: 0px 4px 17px -2px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  border-radius: ${(props) => styles[props.variant].borderRadius};
  &:hover {
    background-color: ${(props) => styles[props.variant].hoverBackgroundColor};
    border: ${(props) => styles[props.variant].hoverBorder};
    color: ${(props) => styles[props.variant].hoverColor};
    transition: 0.2s;
  }
`;